import { AdminBillingListBase } from '~services/admin/billingList/types';

export const getBillingListLabelText = (
  billingList: AdminBillingListBase,
): string => {
  let text = billingList.description;

  if (billingList.billingListCode) {
    text += ` (${billingList.billingListCode})`;
  }

  return text;
};
